export function htmlParser(node) {
  const parser = new DOMParser();

  const document = parser.parseFromString(node, "text/html");

  return document?.body?.querySelector("body > p:nth-of-type(1)")?.textContent;
}
